/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Plugins_FcInputs */

const en_fc_cmp_plugins_fc = /** @type {(inputs: Fc_Cmp_Plugins_FcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No plugin hosting yet`)
};

/**
* | output |
* | --- |
* | "No plugin hosting yet" |
*
* @param {Fc_Cmp_Plugins_FcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_plugins_fc = /** @type {((inputs?: Fc_Cmp_Plugins_FcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Plugins_FcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_plugins_fc(inputs)
});
export { fc_cmp_plugins_fc as "fc.cmp.plugins.fc" }